
import { Component, OnInit, Inject, Output, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';


import { CommonService, AlertService, AdminService } from '../../../_services/';
import { AngularFireStorage } from '@angular/fire/storage';

import { ProjectMapStepNeededDocsComponent } from '../project-map-step-needed-docs/project-map-step-needed-docs.component';

@Component({
  selector: 'app-project-map-step-category',
  templateUrl: './project-map-step-category.component.html',
  styleUrls: ['./project-map-step-category.component.scss']
})

export class ProjectMapStepCategoryComponent implements OnInit {

  addNewProjectMapCategoryForm:FormGroup;
  submitted:Boolean=false;
  successMsg:String;
  errMsg:String;
  errMsg2:String;
  projectMapStep:String;
  projectMapStepId:String;
  projectMapField:any[]=[];
  projectMapCat:any[]=[];
  editFieldMode:Boolean=false;
  editFieldId:String;
  selectedFile: File;
  ref:any;
  private subscription: Subscription;
  constructor(
    public dialogRef: MatDialogRef<ProjectMapStepCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private _common : CommonService,
    private _alert : AlertService,
    private _admin : AdminService,
    private afStorage: AngularFireStorage
  ) { }

  ngOnInit() {
    this.projectMapStep = this.data.step? this.data.step:'';
    this.projectMapStepId = this.data.id;
    this.getProjectMapCategoryList();
    this.addNewProjectMapCategoryForm = this.fb.group({
      name : [null, [Validators.required, Validators.maxLength(50)]]
    }) 
  }
  
  hideProjectMapFieldDialog(){
    this.dialogRef.close();
  }

  get fval() {
    return this.addNewProjectMapCategoryForm.controls;
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  getProjectMapCategoryList(){
    this._common.showLoader(true);
    this.subscription = this._admin.getProjectMapCatetoryList(this.projectMapStepId).subscribe(result=>{
      this._common.showLoader(false);
      this.projectMapCat = result;
    },err=>{
      this._common.showLoader(false);
      this._alert.error(err.error.message?err.error.message:'Something went wrong!');
    })
  }

  onFormSubmit():void {
    this.errMsg ="";
    this.successMsg = "";
    this.submitted = true;
    if (this.addNewProjectMapCategoryForm.invalid) {
      return;
    }
    let form = this.addNewProjectMapCategoryForm.value;
    form.uid = localStorage.getItem('uid');
    form.project_map_step_id = this.projectMapStepId;
    
    if(this.editFieldMode==true){

      this._common.showLoader(true);
      let data ={
        name : this.addNewProjectMapCategoryForm.value.name
      }
      this._admin.editProjectMapStepCategory(data,this.editFieldId).then(res => {
        this._common.showLoader(false);
        // this.dialogRef.close();
        // this._alert.success();
        this.editFieldMode = false;
        this.editFieldId = ''; 
        this.submitted = false;
        this.addNewProjectMapCategoryForm.reset();
        this.successMsg = "Project map step Category edited successfully!";
        
      },err=>{
        this._common.showLoader(false);
        this.errMsg = err.message ? err.message: "Something went wrong";
      }) 
     
    }
    else {
      this._common.showLoader(true);
      this._admin.createProjectMapCategory(form).subscribe(res => {
        this._common.showLoader(false);
        this.submitted = false;
        this.addNewProjectMapCategoryForm.reset();
        this.successMsg = res.message;
      },err=>{
        this.dialogRef.close();
        this._common.showLoader(false);
        this.errMsg = err.error.message?err.error.message:'Something went wrong!';
      }) 
      
    }
  }

  deleteProjectMapCategoryById(uid){
    this._common.showLoader(true);
    this._admin.deleteProjectMapCategoryById(uid).then((res)=>{
      this.cancelEdit();
      this._common.showLoader(false);
      this.successMsg = 'Project map field deleted successfully!';
    }).catch(err=>{
      this._common.showLoader(false);
      this.errMsg = err.error.message?err.error.message:'Something went wrong!';
    })
  }
  openEditProjectMapFieldDialog(id,data){
    this.successMsg = "";
    this.errMsg = "";
    this.editFieldMode = true;
    this.editFieldId = id; 
    this.addNewProjectMapCategoryForm.patchValue({
      name : data.name,
      field_type : data.field_type,
      notify : data.notify
    })   
  }

  cancelEdit(){
    this.editFieldMode = false;
    this.editFieldId = ''; 
    this.addNewProjectMapCategoryForm.reset();
  }

  openProjectMapCategoryFilesDialog(doc,id){
    this.successMsg = "";
    this.errMsg = "";
    let dialogRef = this.dialog.open(ProjectMapStepNeededDocsComponent, {
      width: 'auto',
      data : {
        name : doc.name,
        project_map_step_id : doc.project_map_step_id,
        id : id
      }
    });

    dialogRef.afterClosed().subscribe(response => {
    })
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
  }


}
